import enhancedFetch from '../utils/fetch-json';
import { KINDERGARTEN_TYPE, mapSchoolFromUdir, SCHOOL_TYPE } from '../skolelop/school-model';

export const registerSchoolForEvent =
    ({ body, eventId }) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = `${state.baseURL}/api/public/school/event/${eventId}`;

        return enhancedFetch({
            url: fullUrl,
            options: {
                method: 'POST',
                body,
            },
            dispatch,
            getState,
        });
    };

export const fetchSchoolEventIfSchoolIsRegistered =
    ({ eventId, schoolOrgId }) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = `${state.baseURL}/api/public/school/event/${eventId}/org/${schoolOrgId}`;

        return enhancedFetch({
            url: fullUrl,
            options: {
                method: 'GET',
            },
            dispatch,
            getState,
        });
    };

export const fetchSchoolEventAdminData =
    ({ secretId }) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = `${state.baseURL}/api/public/school/event/admin/${secretId}`;

        return enhancedFetch({
            url: fullUrl,
            options: {
                method: 'GET',
            },
            dispatch,
            getState,
        });
    };

export const searchForSchool = async ({ type = SCHOOL_TYPE, schoolName }) => {
    const url =
        type === KINDERGARTEN_TYPE
            ? 'https://data-nbr.udir.no/v3/enheter/sok'
            : 'https://data-nsr.udir.no/v3/enheter/sok';

    if (!schoolName) {
        return null;
    }

    const udirSchoolsRaw = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            fritekstSoek: schoolName,
            inkluderNedlagte: false,
            inkluderAktive: true,
            ...(type === SCHOOL_TYPE ? { inkluderSkoler: true } : {}),
            ...(type === KINDERGARTEN_TYPE ? { InkluderBarnehager: true } : {}),
            inkluderEiere: false,
            inkluderAndreEnheter: false,
        }),
    });

    const udirSchools = await udirSchoolsRaw.json();
    if (udirSchools) {
        return udirSchools.map(mapSchoolFromUdir);
    } else {
        return [];
    }
};
